<script setup>
import { ref, watch, onMounted } from 'vue'
import axios from '../services/api'
import Cookies from "js-cookie"

const props = defineProps({
  modelValue: {
    type: String,
    default: ""
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const languages = ref([])
const selected = ref(props.modelValue || 'en')

onMounted(async () => {
  try {
    const res = await axios.get('/languages', {
      headers: {
        "api-key": Cookies.get("authToken"),
      },
    })
    languages.value = res.data.languages || []
  } catch (e) {
    console.error('Failed to fetch languages', e)
  }
})

// When the dropdown changes, tell the parent
watch(selected, (val) => {
  emit('update:modelValue', val)
  emit('change', val)
})

// Keep in sync with parent changes
watch(
  () => props.modelValue,
  (val) => {
    selected.value = val || 'en'
  }
)

</script>

<template>
  <select v-model="selected" class="form-select w-auto d-inline-block">
    <option value="" disabled>Select Language</option>
    <option v-for="lang in languages" :key="lang.code" :value="lang.code">
      {{ lang.language }}
    </option>
  </select>
</template>
